import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import ProjectPreview from "./fragments/ProjectPreview";
import { MarginContainer, Loader, VBox } from "@liro_u/react-components";
import {
  SideMove,
  Opacity as OpacityAnimation,
} from "@liro_u/react-animation-components";

import { routes } from "@liro_u/cms-front";

import { useAuthContext } from "@liro_u/react-auth-components";
import { useVerifyAuth } from "@liro_u/react-auth-components";

const AllProjectPreview = ({ ProjectType, style }) => {
  const { user } = useAuthContext();
  const [projects, setProjects] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const { verifyAuth } = useVerifyAuth();

  useEffect(() => {
    const fetchFromDataBase = async () => {
      setIsLoading(true);
      const headers = {};
      if (user) {
        headers.Authorization = `Baerer ${user.token}`;
      }
      const response = await fetch(
        process.env.REACT_APP_PROXY + "/api/project/all/" + ProjectType,
        { headers }
      );

      const json = await response.json();

      if (response.ok) {
        setProjects(json);
      } else {
      }
      setIsLoading(false);
    };
    if (ProjectType) {
      fetchFromDataBase();
    }
  }, [ProjectType, user]);

  const createNewProject = async () => {
    setIsCreating(true);
    const response = await fetch(
      process.env.REACT_APP_PROXY + "/api/project/",
      {
        method: "POST",
        body: JSON.stringify({ type: ProjectType }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Baerer ${user.token}`,
        },
      }
    );

    const json = await response.json();

    if (response.ok) {
      navigate(routes.page + "/" + json._id);
    } else {
      verifyAuth(json);
    }
    setIsCreating(false);
  };

  const renderProjects = () => {
    let children = [];
    if (user) {
      children.push(
        <ProjectPreview
          key={-1}
          name={{
            fr: "Add " + ProjectType + " project",
            en: "Ajouter un " + ProjectType + " project",
          }}
          style={{ cursor: "pointer" }}
          onClick={isCreating ? () => {} : createNewProject}
        />
      );
    }
    projects.forEach((project, index) => {
      children.push(
        <SideMove
          translateXStart={(index % 2 === 0 ? "" : "-") + "100%"}
          key={index}
        >
          <OpacityAnimation>
            <ProjectPreview
              name={project.name}
              _id={project._id}
              image={project.image}
              project={project}
            />
          </OpacityAnimation>
        </SideMove>
      );
    });
    return children;
  };

  return (
    <div className="favProjectPreview" style={{ ...style }}>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <MarginContainer margin={"30px"}>
            {(projects && projects.length > 0) || user ? (
              <VBox gap="10px">{renderProjects()}</VBox>
            ) : (
              <h1>Pas de Projet</h1>
            )}
          </MarginContainer>
        </>
      )}
    </div>
  );
};

export default AllProjectPreview;
